import { Facebook, Send } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export function ShareWin({ text, testId = "share-win", dark = false }) {
  const { user } = useAuth();
  const link = `${window.location.origin}/registrieren${user?.referral_code ? `?ref=${user.referral_code}` : ""}`;
  const full = `${text} Komm auch in die itzPlay Community 💖 ${link}`;
  const fb = () => {
    navigator.clipboard?.writeText(full).catch(() => {});
    toast.success("Text kopiert – füge ihn in deinen Facebook-Beitrag ein ✨");
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`, "fb-share", "width=620,height=560,noopener");
  };
  const messenger = () => {
    if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) { window.location.href = `fb-messenger://share/?link=${encodeURIComponent(link)}`; return; }
    navigator.clipboard?.writeText(full).catch(() => {});
    toast.success("Text kopiert – füge ihn im Messenger ein 💬");
    window.open("https://www.messenger.com/", "_blank", "noopener,noreferrer");
  };
  return (
    <div className="space-y-2" data-testid={testId}>
      <p className={`text-xs font-bold ${dark ? "text-white/70" : "text-slate-500"}`}>Mit Freunden teilen</p>
      <div className="flex gap-2 justify-center">
        <button onClick={fb} data-testid={`${testId}-facebook`} className="inline-flex items-center gap-1.5 px-4 h-10 rounded-full bg-[#1877F2] hover:bg-[#166FE5] text-white text-sm font-bold transition-colors"><Facebook className="w-4 h-4 fill-white" strokeWidth={0} /> Facebook</button>
        <button onClick={messenger} data-testid={`${testId}-messenger`} className="inline-flex items-center gap-1.5 px-4 h-10 rounded-full bg-gradient-to-r from-[#00B2FF] via-[#7B61FF] to-[#FF5C87] text-white text-sm font-bold hover:opacity-90 transition-opacity"><Send className="w-4 h-4" /> Messenger</button>
      </div>
    </div>
  );
}
